import { render } from "./lei-register.vue?vue&type=template&id=66ecb4eb&scoped=true&ts=true"
import script from "./lei-register.vue?vue&type=script&lang=ts"
export * from "./lei-register.vue?vue&type=script&lang=ts"

import "./lei-register.vue?vue&type=style&index=0&id=66ecb4eb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ecb4eb"]])

export default __exports__